import { render, staticRenderFns } from "./UnAssessmentStuDialog.vue?vue&type=template&id=509befff&scoped=true"
import script from "./UnAssessmentStuDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UnAssessmentStuDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UnAssessmentStuDialog.vue?vue&type=style&index=0&id=509befff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509befff",
  null
  
)

export default component.exports